var map = {
	"./audio-placeholder": 670,
	"./audio-placeholder.png": 670,
	"./avatar-missing": 457,
	"./avatar-missing.png": 457,
	"./avatar-missing.svg": 870,
	"./halloween/clouds": 671,
	"./halloween/clouds.png": 671,
	"./halloween/halloween-emblem": 672,
	"./halloween/halloween-emblem.svg": 672,
	"./halloween/spider": 673,
	"./halloween/spider.svg": 673,
	"./halloween/spiderweb": 674,
	"./halloween/spiderweb.svg": 674,
	"./halloween/starfield": 675,
	"./halloween/starfield.png": 675,
	"./halloween/twinkle": 676,
	"./halloween/twinkle.svg": 676,
	"./header-missing": 479,
	"./header-missing.png": 479,
	"./reticle": 677,
	"./reticle.png": 677,
	"./soapbox-logo": 480,
	"./soapbox-logo-white": 481,
	"./soapbox-logo-white.svg": 481,
	"./soapbox-logo.svg": 480,
	"./sprite-post-functions": 678,
	"./sprite-post-functions.png": 678,
	"./video-placeholder": 679,
	"./video-placeholder.png": 679,
	"./void": 680,
	"./void.png": 680,
	"./web-push/web-push-icon_expand": 681,
	"./web-push/web-push-icon_expand.png": 681,
	"./web-push/web-push-icon_favourite": 682,
	"./web-push/web-push-icon_favourite.png": 682,
	"./web-push/web-push-icon_reblog": 683,
	"./web-push/web-push-icon_reblog.png": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 869;